import { Controller } from "@hotwired/stimulus";
import consumer from "../consumer";

export default class extends Controller {
  static targets = ["progress"];
  static values = {
    jobId: Number,
  };

  connect() {
    this.subscribe();
  }

  disconnect() {
    this.unsubscribe();
  }

  subscribe() {
    if (this.subscription) {
      return; // Already subscribed
    }

    this.subscription = consumer.subscriptions.create(
      {
        channel: "WorkflowProgressChannel",
        analysis_job_id: this.jobIdValue,
      },
      {
        connected: () => {
          console.log(
            "✅ Connected to WorkflowProgressChannel for job",
            this.jobIdValue
          );
        },

        disconnected: () => {
          console.log("❌ Disconnected from WorkflowProgressChannel");
        },

        received: (data) => {
          console.log("📨 Received broadcast data:", data);
          if (data.action === "update_progress") {
            console.log("🔄 Updating progress with HTML length:", data.html?.length);
            this.updateProgress(data.html);
          } else {
            console.warn("⚠️ Received unknown action:", data.action);
          }
        },
      }
    );
  }

  unsubscribe() {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = null;
    }
  }

  updateProgress(html) {
    console.log("🎯 UpdateProgress called for job:", this.jobIdValue);
    
    // Check if target element exists
    const targetId = `workflow_progress_${this.jobIdValue}`;
    const targetElement = document.getElementById(targetId);
    console.log("🔍 Target element exists:", !!targetElement, "ID:", targetId);
    
    // Create a turbo stream to update the progress
    const streamElement = document.createElement("template");
    streamElement.innerHTML = `
      <turbo-stream action="replace" target="${targetId}">
        <template>${html}</template>
      </turbo-stream>
    `;

    console.log("📤 Turbo stream message:", streamElement.innerHTML.substring(0, 200));
    
    // Process the turbo stream
    try {
      Turbo.renderStreamMessage(streamElement.innerHTML);
      console.log("✅ Turbo stream rendered successfully");
    } catch (error) {
      console.error("❌ Error rendering turbo stream:", error);
    }
  }

  // Manual refresh action (fallback)
  refresh() {
    fetch(`/analysis_jobs/${this.jobIdValue}/progress`, {
      headers: {
        "Accept": "text/vnd.turbo-stream.html",
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .then((response) => response.text())
      .then((html) => Turbo.renderStreamMessage(html))
      .catch((error) =>
        console.warn("Failed to refresh workflow progress:", error)
      );
  }
}
